module.exports = __webpack_public_path__ + "img/city.f8ff58da.svg";